'use client'

import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'

export type ShellPanelsContextValue = {
  activityOpen: boolean
  setActivityOpen: (open: boolean) => void
  openActivity: () => void
}

const ShellPanelsContext = createContext<ShellPanelsContextValue | null>(null)

export function ShellPanelsProvider({ children }: { children: React.ReactNode }) {
  const [activityOpen, setActivityOpen] = useState(false)

  const openActivity = useCallback(() => {
    setActivityOpen(true)
  }, [])

  const value = useMemo(
    (): ShellPanelsContextValue => ({
      activityOpen,
      setActivityOpen,
      openActivity,
    }),
    [activityOpen, openActivity]
  )

  return <ShellPanelsContext.Provider value={value}>{children}</ShellPanelsContext.Provider>
}

export function useShellPanels(): ShellPanelsContextValue {
  const ctx = useContext(ShellPanelsContext)
  if (!ctx) throw new Error('useShellPanels must be used within ShellPanelsProvider')
  return ctx
}
